import FormattedMessage from 'I18n/components/FormattedMessage';
import UITable from 'UIComponents/table/UITable';
import { STAIRSTEP } from 'customer-data-objects/product/Pricing';
import { TieredPriceRow } from './table/TieredPriceRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceTable = ({
  tierRangesAndPrices,
  pricingModel,
  currencyCode
}) => {
  return /*#__PURE__*/_jsxs(UITable, {
    "data-test-id": "tiered-price-table",
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.tieredPricing.table.headers.tier"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.tieredPricing.table.headers.range"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: pricingModel === STAIRSTEP ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.tieredPricing.table.headers.tierPrice"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.tieredPricing.table.headers.unitPrice"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: tierRangesAndPrices === null || tierRangesAndPrices === void 0 ? void 0 : tierRangesAndPrices.map(tierRangeAndPrice => {
        return /*#__PURE__*/_jsx(TieredPriceRow, {
          tierRangeAndPrice: tierRangeAndPrice,
          currencyCode: currencyCode
        }, tierRangeAndPrice.start);
      })
    })]
  });
};